import './Navigation.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <span className="logo-text">Jasmin Meghan</span>
        </Link>
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <li><Link to="/" className="nav-link" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about" className="nav-link" onClick={closeMenu}>About</Link></li>
          <li><Link to="/education" className="nav-link" onClick={closeMenu}>Education</Link></li>
          <li><Link to="/projects" className="nav-link" onClick={closeMenu}>Projects</Link></li>
          <li><Link to="/skills" className="nav-link" onClick={closeMenu}>Skills</Link></li>
          <li><Link to="/achievements" className="nav-link" onClick={closeMenu}>Achievements</Link></li>
          <li><Link to="/certificates" className="nav-link" onClick={closeMenu}>Certificates</Link></li>
          <li><Link to="/competitions" className="nav-link" onClick={closeMenu}>Competitions</Link></li>
          <li><Link to="/leadership" className="nav-link" onClick={closeMenu}>Leadership</Link></li>
          <li><Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
